export enum SystemUserPasswordCodeInfoType {
    LinkOpened = 'a0f854d5-6544-4a24-ac5c-c2723119fc16',
    LinkExpired = 'b1329c42-9c25-43eb-b07a-ba4142d58d5d',
    PasswordCreated = '0beffd15-dce0-4dd7-b85b-49ce48f29ba8',
    PasswordUpdated = '62cdb82c-3aaf-4c9d-96b8-aa8571290f4e',
    LinkClosed = '766a1057-6ce9-40fa-89f9-53ae167b4a6f'
  }
